import api from './api';
import type { AdminDashboardStats, SystemHealth, AdminActivity } from '@/types/admin';

export const adminDashboardService = {
  async getStats(): Promise<AdminDashboardStats> {
    try {
      const response = await api.get('/admin/dashboard/stats/');
      return response.data;
    } catch {
      // Return mock data if endpoint doesn't exist yet
      return {
        totalUsers: 156,
        totalInsurers: 12,
        totalProducts: 48,
        totalPolicies: 1250,
        totalPremium: 45000000,
        activeQuotes: 89,
        pendingClaims: 23,
        upcomingRenewals: 145,
        trends: {
          users: 12,
          insurers: 8,
          products: 5,
          policies: 15,
        },
      };
    }
  },

  async getSystemHealth(): Promise<SystemHealth> {
    try {
      const response = await api.get('/admin/dashboard/health/');
      return response.data;
    } catch {
      // Return mock data if endpoint doesn't exist yet
      return {
        database: 'healthy',
        api: 'healthy',
        integrations: [
          { id: '1', name: 'ICICI Lombard', status: 'connected', lastSync: new Date().toISOString() },
          { id: '2', name: 'HDFC Ergo', status: 'connected', lastSync: new Date().toISOString() },
          { id: '3', name: 'Bajaj Allianz', status: 'disconnected', lastSync: new Date(Date.now() - 3600000).toISOString() },
        ],
        lastSync: new Date().toISOString(),
      };
    }
  },

  async getRecentActivity(limit: number = 10): Promise<AdminActivity[]> {
    try {
      const response = await api.get('/audit/logs/', { params: { limit } });
      return response.data.results || response.data;
    } catch {
      // Return mock data if endpoint doesn't exist yet
      return [
        {
          id: '1',
          type: 'create',
          title: 'New user created',
          description: 'User john.doe@example.com was created',
          timestamp: new Date(Date.now() - 300000).toISOString(),
          user: { id: '1', name: 'Admin User' },
        },
        {
          id: '2',
          type: 'update',
          title: 'Product updated',
          description: 'Motor Comprehensive Premium was modified',
          timestamp: new Date(Date.now() - 600000).toISOString(),
          user: { id: '1', name: 'Admin User' },
        },
        {
          id: '3',
          type: 'login',
          title: 'User logged in',
          description: 'broker@example.com logged in from 192.168.1.1',
          timestamp: new Date(Date.now() - 900000).toISOString(),
          user: { id: '2', name: 'Broker Admin' },
        },
        {
          id: '4',
          type: 'success',
          title: 'Policy issued',
          description: 'Policy #POL-2024-001234 was successfully issued',
          timestamp: new Date(Date.now() - 1200000).toISOString(),
          user: { id: '3', name: 'Sales Executive' },
        },
        {
          id: '5',
          type: 'warning',
          title: 'API rate limit warning',
          description: 'ICICI Lombard API approaching rate limit',
          timestamp: new Date(Date.now() - 1500000).toISOString(),
        },
      ];
    }
  },
};

export default adminDashboardService;
